import styled from '@emotion/styled';
import { GridContainer, getColor, getSpace, Image } from '../../../../../../../ui/index.ts';

export const Container = styled(GridContainer)`
  max-width: 500px;
  padding: ${getSpace('10')} 0;
  background: ${getColor('light-yellow')};
  border-radius: 5px;
`;

export const TitleBlockImage = styled(Image)`
  max-width: 280px;
`;
